module.exports = __webpack_public_path__ + "img/ED5087_FAC3D0_1C0B0C_FC84CC-256px.58e44d4d.png";